// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E8F1FB;
  --brand-glow:     rgba(21, 101, 192, 0.15);
  --brand-glow-md:  rgba(21, 101, 192, 0.28);
  --accent:         #0097A7;
  --surface:        #ffffff;
  --surface-2:      #F5F7FA;
  --surface-3:      #EBF1FB;
  --page-bg:        #F0F2F5;
  --border:         #DCE8F8;
  --border-strong:  #BBCFF5;
  --text-primary:   #0C1A2E;
  --text-secondary: #334D6E;
  --text-muted:     #7090B0;
  --success:        #16A34A;
  --danger:         #DC2626;
  --danger-soft:    #FFF0F0;
  --font:           'Plus Jakarta Sans', sans-serif;
  --font-serif:     'Lora', serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      20px;
  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);
  --shadow-md:      0 4px 16px rgba(0,0,0,0.08), 0 12px 32px rgba(21,101,192,0.09);
  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);
}

* { box-sizing: border-box; }

/* ======================================
   CONTAINER
====================================== */
.about_container {
  display: flex;
  justify-content: center;
  font-family: var(--font);
  width: 100%;
  max-width: 860px;
  margin: 20px auto;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background-color: var(--surface);
  box-shadow: var(--shadow-md);
  position: relative;
}

/* Top accent bar */
.about_container::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  z-index: 1;
}

/* ======================================
   CONTENT
====================================== */
.about_content {
  width: 100%;
  padding: 28px 32px 32px;
  text-align: left;
  box-sizing: border-box;
}

/* ======================================
   HEADER
====================================== */
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 2px solid var(--brand-soft);
}

.header-container h2,
.header-container h3 {
  font-family: var(--font);
  font-size: 16px;
  font-weight: 800;
  color: var(--brand);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* ======================================
   PARAGRAPH CARDS
====================================== */
.about-paragraphs {
  margin-bottom: 20px;
}

.paragraph-container {
  margin-bottom: 10px;
  padding: 14px 18px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-left: 4px solid var(--brand-soft);
  border-radius: var(--radius-md);
  transition: border-left-color 0.22s var(--ease), box-shadow 0.22s var(--ease);
}

.paragraph-container:hover {
  border-left-color: var(--brand-mid);
  box-shadow: var(--shadow-sm);
}

.para {
  font-family: var(--font-serif);
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-secondary);
  margin: 0;
}

/* ======================================
   INFO GRID — notification-card style rows
====================================== */
.about-info-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.about-info-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-left: 4px solid var(--brand-soft);
  border-radius: var(--radius-md);
  transition: border-left-color 0.2s var(--ease), box-shadow 0.2s var(--ease), background 0.2s;
  animation: aboutRowIn 0.22s ease both;
}

@keyframes aboutRowIn {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* stagger */
.about-info-row:nth-child(1) { animation-delay: 0.03s; }
.about-info-row:nth-child(2) { animation-delay: 0.06s; }
.about-info-row:nth-child(3) { animation-delay: 0.09s; }
.about-info-row:nth-child(4) { animation-delay: 0.12s; }
.about-info-row:nth-child(5) { animation-delay: 0.15s; }
.about-info-row:nth-child(6) { animation-delay: 0.18s; }
.about-info-row:nth-child(7) { animation-delay: 0.21s; }
.about-info-row:nth-child(8) { animation-delay: 0.24s; }

.about-info-row:hover {
  border-left-color: var(--brand-mid);
  background: #f0f6ff;
  box-shadow: var(--shadow-sm);
}

/* Icon pill */
.about-info-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--brand-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--brand);
}

/* Body */
.about-info-body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.about-info-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--text-muted);
}

.about-info-value {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  line-height: 1.4;
  word-break: break-word;
}

.about-info-link {
  font-size: 14px;
  font-weight: 600;
  color: var(--brand);
  text-decoration: none;
  border-bottom: 1.5px solid var(--brand-soft);
  transition: color 0.18s, border-color 0.18s;
  word-break: break-all;
}

.about-info-link:hover {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.about-info-empty {
  font-size: 13px;
  color: var(--text-muted);
  font-style: italic;
}

/* ======================================
   EDIT BUTTONS (kept for EditAbout reuse)
====================================== */
.edit_button,
.save-btn {
  padding: 8px 18px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  margin-left: 10px;
  box-shadow: 0 2px 8px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.edit_button:hover,
.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 16px var(--brand-glow-md);
}

.add-btn {
  padding: 8px 18px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 2px 8px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 16px var(--brand-glow-md);
}

.delete-btn {
  padding: 7px 14px;
  background: var(--danger-soft);
  color: var(--danger);
  border: 1.5px solid #FECACA;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  margin-top: 10px;
  transition: all 0.18s var(--ease);
}

.delete-btn:hover {
  background: var(--danger);
  color: white;
  border-color: var(--danger);
  transform: translateY(-1px);
}

/* ======================================
   EDITABLE INPUTS (kept for EditAbout)
====================================== */
.editable-text {
  width: 100%;
  min-height: 130px;
  padding: 12px 15px;
  font-size: 14px;
  font-family: var(--font);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background-color: var(--surface-2);
  outline: none;
  line-height: 1.7;
  resize: vertical;
  box-sizing: border-box;
  margin-bottom: 10px;
  color: var(--text-primary);
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.editable-text:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
  background-color: #fff;
}

.editable-input {
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  font-family: var(--font);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background-color: var(--surface-2);
  outline: none;
  box-sizing: border-box;
  color: var(--text-primary);
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.editable-input:focus {
  border-color: var(--brand-mid);
  box-shadow: var(--shadow-focus);
  background-color: #fff;
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 992px) {
  .about_container { width: 95%; margin: 15px auto; }
  .about_content   { padding: 22px 22px 26px; }
  .para            { font-size: 14.5px; }
  .header-container { flex-direction: column; align-items: flex-start; gap: 8px; }
  .edit_button { margin-left: 0; }
}

@media (max-width: 768px) {
  .about_container { width: 100%; margin: 10px auto; border-radius: var(--radius-md); }
  .about_content   { padding: 18px 16px 22px; }
  .para            { font-size: 14px; line-height: 1.65; }
  .about-info-row  { padding: 10px 12px; gap: 10px; }
  .about-info-icon { width: 30px; height: 30px; }
  .about-info-label{ font-size: 10.5px; }
  .about-info-value,
  .about-info-link  { font-size: 13.5px; }
  .about-info-empty { font-size: 12.5px; }
  .header-container { flex-direction: column; align-items: flex-start; gap: 8px; }
  .edit_button { margin-left: 0; }
}

@media (max-width: 480px) {
  .about_content   { padding: 14px 12px 18px; }
  .para            { font-size: 13px; line-height: 1.6; }
  .about-info-row  { padding: 9px 10px; gap: 8px; }
  .about-info-icon { width: 28px; height: 28px; }
  .about-info-label{ font-size: 10px; }
  .about-info-value,
  .about-info-link  { font-size: 13px; }
  .about-info-empty { font-size: 12px; }
}

@media (max-width: 320px) {
  .about_content  { padding: 10px 10px 14px; }
  .para           { font-size: 12px; }
  .about-info-row { padding: 8px; gap: 7px; }
  .about-info-icon{ width: 26px; height: 26px; }
}

/* ======================================
   TYPE BADGE  (Business / Individual)
====================================== */
.about-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 100px;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.about-type-badge.firm {
  background: #E8F1FB;
  color: #1565C0;
  border: 1px solid rgba(21,101,192,0.2);
}

.about-type-badge.individual {
  background: #E8F5E9;
  color: #2E7D32;
  border: 1px solid rgba(46,125,50,0.2);
}

/* ======================================
   SECTION HEAD  (Business Details / Personal Details)
====================================== */
.about-section-head {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-muted);
  margin: 18px 0 10px;
  padding-left: 2px;
}

/* ======================================
   LOADING SKELETON
====================================== */
.about-skeleton {
  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);
  background-size: 200% 100%;
  animation: aboutShimmer 1.4s infinite;
  border-radius: 6px;
}

.about-skeleton.circle {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  flex-shrink: 0;
}

.about-skeleton.line {
  height: 11px;
  border-radius: 6px;
}

.about-skeleton.line.short  { width: 80px;  }
.about-skeleton.line.medium { width: 140px; }

@keyframes aboutShimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ======================================
   EMPTY STATE
====================================== */
.about-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: var(--text-muted);
  gap: 10px;
}

.about-empty-state span {
  font-size: 36px;
}

.about-empty-state p {
  font-size: 14px;
  margin: 0;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/components/about.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+BAA+B;EAC/B,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,8EAA8E;EAC9E,gFAAgF;EAChF,iDAAiD;AACnD;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,+FAA+F;EAC/F,oDAAoD;EACpD,UAAU;AACZ;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;wCAEwC;AACxC;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,wCAAwC;EACxC,+BAA+B;EAC/B,6EAA6E;AAC/E;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,wCAAwC;EACxC,+BAA+B;EAC/B,4FAA4F;EAC5F,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,YAAY;AACZ,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;;AAEvD;EACE,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;wCAEwC;AACxC;;EAEE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,mEAAmE;AACrE;;AAEA;;EAEE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;wCAEwC;AACxC;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,wCAAwC;EACxC,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;wCAEwC;AACxC;EACE,mBAAmB,UAAU,EAAE,iBAAiB,EAAE;EAClD,mBAAmB,uBAAuB,EAAE;EAC5C,mBAAmB,iBAAiB,EAAE;EACtC,oBAAoB,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EAC/E,eAAe,cAAc,EAAE;AACjC;;AAEA;EACE,mBAAmB,WAAW,EAAE,iBAAiB,EAAE,+BAA+B,EAAE;EACpF,mBAAmB,uBAAuB,EAAE;EAC5C,mBAAmB,eAAe,EAAE,iBAAiB,EAAE;EACvD,mBAAmB,kBAAkB,EAAE,SAAS,EAAE;EAClD,mBAAmB,WAAW,EAAE,YAAY,EAAE;EAC9C,mBAAmB,iBAAiB,EAAE;EACtC;sBACoB,iBAAiB,EAAE;EACvC,oBAAoB,iBAAiB,EAAE;EACvC,oBAAoB,sBAAsB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EAC/E,eAAe,cAAc,EAAE;AACjC;;AAEA;EACE,mBAAmB,uBAAuB,EAAE;EAC5C,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;EACtD,mBAAmB,iBAAiB,EAAE,QAAQ,EAAE;EAChD,mBAAmB,WAAW,EAAE,YAAY,EAAE;EAC9C,mBAAmB,eAAe,EAAE;EACpC;sBACoB,eAAe,EAAE;EACrC,oBAAoB,eAAe,EAAE;AACvC;;AAEA;EACE,kBAAkB,uBAAuB,EAAE;EAC3C,kBAAkB,eAAe,EAAE;EACnC,kBAAkB,YAAY,EAAE,QAAQ,EAAE;EAC1C,kBAAkB,WAAW,EAAE,YAAY,EAAE;AAC/C;;AAEA;;wCAEwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qCAAqC;AACvC;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;wCAEwC;AACxC;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,8BAA8B,WAAW,GAAG;AAC5C,8BAA8B,YAAY,EAAE;;AAE5C;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Lora:ital,wght@0,400;0,600;1,400&display=swap');\n\n/* ======================================\n   DESIGN TOKENS\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E8F1FB;\n  --brand-glow:     rgba(21, 101, 192, 0.15);\n  --brand-glow-md:  rgba(21, 101, 192, 0.28);\n  --accent:         #0097A7;\n  --surface:        #ffffff;\n  --surface-2:      #F5F7FA;\n  --surface-3:      #EBF1FB;\n  --page-bg:        #F0F2F5;\n  --border:         #DCE8F8;\n  --border-strong:  #BBCFF5;\n  --text-primary:   #0C1A2E;\n  --text-secondary: #334D6E;\n  --text-muted:     #7090B0;\n  --success:        #16A34A;\n  --danger:         #DC2626;\n  --danger-soft:    #FFF0F0;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --font-serif:     'Lora', serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      20px;\n  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);\n  --shadow-md:      0 4px 16px rgba(0,0,0,0.08), 0 12px 32px rgba(21,101,192,0.09);\n  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);\n}\n\n* { box-sizing: border-box; }\n\n/* ======================================\n   CONTAINER\n====================================== */\n.about_container {\n  display: flex;\n  justify-content: center;\n  font-family: var(--font);\n  width: 100%;\n  max-width: 860px;\n  margin: 20px auto;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background-color: var(--surface);\n  box-shadow: var(--shadow-md);\n  position: relative;\n}\n\n/* Top accent bar */\n.about_container::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 60%, var(--accent) 100%);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  z-index: 1;\n}\n\n/* ======================================\n   CONTENT\n====================================== */\n.about_content {\n  width: 100%;\n  padding: 28px 32px 32px;\n  text-align: left;\n  box-sizing: border-box;\n}\n\n/* ======================================\n   HEADER\n====================================== */\n.header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n  border-bottom: 2px solid var(--brand-soft);\n}\n\n.header-container h2,\n.header-container h3 {\n  font-family: var(--font);\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--brand);\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* ======================================\n   PARAGRAPH CARDS\n====================================== */\n.about-paragraphs {\n  margin-bottom: 20px;\n}\n\n.paragraph-container {\n  margin-bottom: 10px;\n  padding: 14px 18px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--brand-soft);\n  border-radius: var(--radius-md);\n  transition: border-left-color 0.22s var(--ease), box-shadow 0.22s var(--ease);\n}\n\n.paragraph-container:hover {\n  border-left-color: var(--brand-mid);\n  box-shadow: var(--shadow-sm);\n}\n\n.para {\n  font-family: var(--font-serif);\n  font-size: 15px;\n  line-height: 1.8;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* ======================================\n   INFO GRID — notification-card style rows\n====================================== */\n.about-info-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.about-info-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 11px 14px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-left: 4px solid var(--brand-soft);\n  border-radius: var(--radius-md);\n  transition: border-left-color 0.2s var(--ease), box-shadow 0.2s var(--ease), background 0.2s;\n  animation: aboutRowIn 0.22s ease both;\n}\n\n@keyframes aboutRowIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* stagger */\n.about-info-row:nth-child(1) { animation-delay: 0.03s; }\n.about-info-row:nth-child(2) { animation-delay: 0.06s; }\n.about-info-row:nth-child(3) { animation-delay: 0.09s; }\n.about-info-row:nth-child(4) { animation-delay: 0.12s; }\n.about-info-row:nth-child(5) { animation-delay: 0.15s; }\n.about-info-row:nth-child(6) { animation-delay: 0.18s; }\n.about-info-row:nth-child(7) { animation-delay: 0.21s; }\n.about-info-row:nth-child(8) { animation-delay: 0.24s; }\n\n.about-info-row:hover {\n  border-left-color: var(--brand-mid);\n  background: #f0f6ff;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Icon pill */\n.about-info-icon {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: var(--brand-soft);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--brand);\n}\n\n/* Body */\n.about-info-body {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.about-info-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--text-muted);\n}\n\n.about-info-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-primary);\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.about-info-link {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--brand);\n  text-decoration: none;\n  border-bottom: 1.5px solid var(--brand-soft);\n  transition: color 0.18s, border-color 0.18s;\n  word-break: break-all;\n}\n\n.about-info-link:hover {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.about-info-empty {\n  font-size: 13px;\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n/* ======================================\n   EDIT BUTTONS (kept for EditAbout reuse)\n====================================== */\n.edit_button,\n.save-btn {\n  padding: 8px 18px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  margin-left: 10px;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.edit_button:hover,\n.save-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 16px var(--brand-glow-md);\n}\n\n.add-btn {\n  padding: 8px 18px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 2px 8px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.add-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 16px var(--brand-glow-md);\n}\n\n.delete-btn {\n  padding: 7px 14px;\n  background: var(--danger-soft);\n  color: var(--danger);\n  border: 1.5px solid #FECACA;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  margin-top: 10px;\n  transition: all 0.18s var(--ease);\n}\n\n.delete-btn:hover {\n  background: var(--danger);\n  color: white;\n  border-color: var(--danger);\n  transform: translateY(-1px);\n}\n\n/* ======================================\n   EDITABLE INPUTS (kept for EditAbout)\n====================================== */\n.editable-text {\n  width: 100%;\n  min-height: 130px;\n  padding: 12px 15px;\n  font-size: 14px;\n  font-family: var(--font);\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  background-color: var(--surface-2);\n  outline: none;\n  line-height: 1.7;\n  resize: vertical;\n  box-sizing: border-box;\n  margin-bottom: 10px;\n  color: var(--text-primary);\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n}\n\n.editable-text:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n  background-color: #fff;\n}\n\n.editable-input {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 14px;\n  font-family: var(--font);\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  background-color: var(--surface-2);\n  outline: none;\n  box-sizing: border-box;\n  color: var(--text-primary);\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n}\n\n.editable-input:focus {\n  border-color: var(--brand-mid);\n  box-shadow: var(--shadow-focus);\n  background-color: #fff;\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 992px) {\n  .about_container { width: 95%; margin: 15px auto; }\n  .about_content   { padding: 22px 22px 26px; }\n  .para            { font-size: 14.5px; }\n  .header-container { flex-direction: column; align-items: flex-start; gap: 8px; }\n  .edit_button { margin-left: 0; }\n}\n\n@media (max-width: 768px) {\n  .about_container { width: 100%; margin: 10px auto; border-radius: var(--radius-md); }\n  .about_content   { padding: 18px 16px 22px; }\n  .para            { font-size: 14px; line-height: 1.65; }\n  .about-info-row  { padding: 10px 12px; gap: 10px; }\n  .about-info-icon { width: 30px; height: 30px; }\n  .about-info-label{ font-size: 10.5px; }\n  .about-info-value,\n  .about-info-link  { font-size: 13.5px; }\n  .about-info-empty { font-size: 12.5px; }\n  .header-container { flex-direction: column; align-items: flex-start; gap: 8px; }\n  .edit_button { margin-left: 0; }\n}\n\n@media (max-width: 480px) {\n  .about_content   { padding: 14px 12px 18px; }\n  .para            { font-size: 13px; line-height: 1.6; }\n  .about-info-row  { padding: 9px 10px; gap: 8px; }\n  .about-info-icon { width: 28px; height: 28px; }\n  .about-info-label{ font-size: 10px; }\n  .about-info-value,\n  .about-info-link  { font-size: 13px; }\n  .about-info-empty { font-size: 12px; }\n}\n\n@media (max-width: 320px) {\n  .about_content  { padding: 10px 10px 14px; }\n  .para           { font-size: 12px; }\n  .about-info-row { padding: 8px; gap: 7px; }\n  .about-info-icon{ width: 26px; height: 26px; }\n}\n\n/* ======================================\n   TYPE BADGE  (Business / Individual)\n====================================== */\n.about-type-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11.5px;\n  font-weight: 700;\n  padding: 5px 12px;\n  border-radius: 100px;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n}\n\n.about-type-badge.firm {\n  background: #E8F1FB;\n  color: #1565C0;\n  border: 1px solid rgba(21,101,192,0.2);\n}\n\n.about-type-badge.individual {\n  background: #E8F5E9;\n  color: #2E7D32;\n  border: 1px solid rgba(46,125,50,0.2);\n}\n\n/* ======================================\n   SECTION HEAD  (Business Details / Personal Details)\n====================================== */\n.about-section-head {\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--text-muted);\n  margin: 18px 0 10px;\n  padding-left: 2px;\n}\n\n/* ======================================\n   LOADING SKELETON\n====================================== */\n.about-skeleton {\n  background: linear-gradient(90deg, #e0eaf6 25%, #f0f4fb 50%, #e0eaf6 75%);\n  background-size: 200% 100%;\n  animation: aboutShimmer 1.4s infinite;\n  border-radius: 6px;\n}\n\n.about-skeleton.circle {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.about-skeleton.line {\n  height: 11px;\n  border-radius: 6px;\n}\n\n.about-skeleton.line.short  { width: 80px;  }\n.about-skeleton.line.medium { width: 140px; }\n\n@keyframes aboutShimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ======================================\n   EMPTY STATE\n====================================== */\n.about-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-muted);\n  gap: 10px;\n}\n\n.about-empty-state span {\n  font-size: 36px;\n}\n\n.about-empty-state p {\n  font-size: 14px;\n  margin: 0;\n  font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
